import React, { createContext, useContext, useEffect, useState } from "react";
import axios from "axios";

const API = `${process.env.REACT_APP_BACKEND_URL}/api`;
const AuthCtx = createContext(null);
const KEY = "rmm_admin_token";

export function AuthProvider({ children }) {
  const [user, setUser] = useState(null); // null = loading, false = anonymous, object = logged in
  const [token, setToken] = useState(localStorage.getItem(KEY) || "");

  useEffect(() => {
    if (!token) { setUser(false); return; }
    axios.get(`${API}/auth/me`, { headers: { Authorization: `Bearer ${token}` } })
      .then((r) => setUser(r.data))
      .catch(() => { localStorage.removeItem(KEY); setToken(""); setUser(false); });
  }, [token]);

  const login = async (email, password) => {
    const { data } = await axios.post(`${API}/auth/login`, { email, password });
    localStorage.setItem(KEY, data.access_token);
    setToken(data.access_token);
    setUser({ email: data.email, name: data.name });
    return data;
  };
  const logout = () => { localStorage.removeItem(KEY); setToken(""); setUser(false); };

  const auth = (cfg = {}) => ({ ...cfg, headers: { ...(cfg.headers || {}), Authorization: `Bearer ${token}` } });

  return <AuthCtx.Provider value={{ user, token, login, logout, auth }}>{children}</AuthCtx.Provider>;
}

export const useAuth = () => useContext(AuthCtx);
